import { render, staticRenderFns } from "./pos-notes.vue?vue&type=template&id=5b11c836"
import script from "./pos-notes.vue?vue&type=script&lang=js"
export * from "./pos-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports